<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      <div class="tt1">学习卡查询</div>
      <!-- <div class="tt2">国家级I类学分总数1000分/剩余800</div> -->
      <!-- <div class="tt2">省级II类学分总数1000分/剩余500</div> -->
    </div>
    <div class="top">
      <el-select v-model="type"
                 size="small"
                 @change="toUpdate"
                 placeholder="学分匹配状态">
        <el-option v-for="item in typeoptions"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <el-input placeholder="请输入卡号"
                v-model="cdkey"
                size="small"
                style="width:340px">
        <el-button slot="append"
                   @click="toUpdate"
                   icon="el-icon-search"></el-button>
      </el-input>
      <el-input placeholder="请输入姓名/手机号"
                v-model="name"
                size="small"
                style="width:340px">
        <el-button slot="append"
                   @click="toUpdate"
                   icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div class="mid">
      <el-table ref="multipleTable"
                style="width:972px"
                :data="list"
                tooltip-effect="dark"
                class="mtable"
                border>
        <!-- <el-table-column type="selection"
                         width="39"
                         style="text-align: center;">
        </el-table-column> -->
        <el-table-column prop="num"
                         label="卡号"
                         width="120">
        </el-table-column>
        <el-table-column prop="scoreType"
                         width="120"
                         label="学分类型">
        </el-table-column>
        <el-table-column prop="score"
                         width="60"
                         label="面值">
        </el-table-column>
        <el-table-column prop="residueScore"
                         width="80"
                         label="剩余学分">
        </el-table-column>
        <el-table-column prop="year"
                         width="60"
                         label="年度">
        </el-table-column>
        <!-- <el-table-column prop="issuanceDate"
                         width="160"
                         label="发行时间">
        </el-table-column> -->
        <!-- <el-table-column label="学习状态">
          <template slot-scope="scope">{{ scope.row.status==0?'未学习':scope.row.status==1?'已学完':'已考核' }}</template>
        </el-table-column> -->
        <el-table-column prop="expirationTime"
                         width="160"
                         label="过期时间">
        </el-table-column>
        <el-table-column prop="userName"
                         width="80"
                         label="用户姓名">
        </el-table-column>
        <el-table-column prop="mobile"
                         width="110"
                         label="手机号">
        </el-table-column>
        <el-table-column prop="bindDate"
                         width="160"
                         label="分配时间">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="100">
          <template slot-scope="scope">
            <el-button @click="toShowRecord(scope.row)"
                       type="text"
                       size="small">购课记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="购课记录"
                 :visible.sync="isRecordBox"
                 width="600px">
        <el-table :data="RecordBoxList"
                  height="300px"
                  style="width: 100%">
          <el-table-column prop="title"
                           label="项目名称">
          </el-table-column>
          <el-table-column prop="category"
                           width="80"
                           label="项目类别">
          </el-table-column>
          <el-table-column prop="scoreCategory"
                           width="80"
                           label="学分分类">
          </el-table-column>
          <el-table-column prop="score"
                           width="80"
                           label="消耗学分">
          </el-table-column>
          <el-table-column prop="creadate"
                           width="160"
                           label="兑换时间">
          </el-table-column>
        </el-table>
      </el-dialog>
      <pagination v-if="page.total>page.pageSize"
                  isNum
                  :total="page.total"
                  :limit="page.pageSize"
                  :page="page.currentPage"
                  @page-change="pageChange"></pagination>
    </div>

  </div>
</template>
<script>
export default {
  data () {
    return {
      storeName: '',
      page: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      },
      list: [],
      typeoptions: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '已分配'
      }, {
        value: 2,
        label: '未分配'
      }],
      type: 0,
      name: '',
      cdkey: '',
      isRecordBox: false,
      RecordBoxList: []
    }
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
    this.orgid = Number(localStorage.getItem('storeId'))
    this.getList()
  },
  methods: {
    pageChange (val) {
      if (this.page.currentPage == val) return
      this.page.currentPage = val;
      this.getList()
    },
    toUpdate () {
      this.page.currentPage = 1
      this.getList()
    },
    toShowRecord (e) {
      this.httphelper
        .get('/api/LearnProjectApi/GetCardconvertrecord', {
          num: e.num
        })
        .then(res => {
          if (res.code == 200) {
            this.RecordBoxList = res.data
          }
        })
      this.isRecordBox = true
    },
    getList () {
      this.httphelper
        .get('/api/LearnProjectApi/GetOrgLearCardPageList', {
          orgId: this.orgid,
          status: this.type,
          name: this.name,
          num: this.cdkey,
          page: this.page.currentPage,
          limit: this.page.pageSize
        })
        .then(res => {
          if (res.code == 200) {
            this.page.total = res.totalcount
            this.list = res.data
          }
        })
    }
  }
};
</script>

<style lang="scss" scoped>
.toptitle {
    width: 100%;
    box-sizing: border-box;
    height: 57px;
    background: #f6f7fb;
    padding-left: 17px;
    margin: 30px 0 30px 0;
    display: flex;
    align-items: center;
    line-height: 56px;
    .tt1 {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #0b8586;
    }
    .tt2 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        margin-left: 36px;
    }
}
.top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
.mid {
    .mtable {
        width: 100%;
        ::v-deep thead {
            th {
                background-color: #0b8586 !important;
                color: #fff;
            }
        }
    }
}
</style>
